/* flow-strict */

/* eslint-disable camelcase */
import * as React from 'react';
import StripeCard from '/client/src/components/StripeCard/';
import { format } from '../../../utils/amountTransformation';
import { currency } from '../../../constants';
import {
  canCheckout
} from '/client/src/utils/buyService';
import { TicketFeeType } from '/client/src/constants/';

export const StepPayment = (props) => {
  const handleStripSubmit = () => {
    console.log('Submit');
  };

  let total = 0;

  let total_with_discount = 0;


  if (props.isIssetDiscount) {
    const tax = (ticket, _price) => {
      if (ticket.tax_use_percentage) {
        return _price * (ticket.tax_percentage / 100);
      }

      return ticket.tax;
    };

    const _fee = (ticket) => {
      let fee = ticket.merchant_fee;

      if (ticket.fee_type === TicketFeeType.ExcludeFee) {
        fee = ticket.discount_fee || (ticket.merchant_fee +
          ticket.payment_method_additional_fee +
          ticket.payment_method_additional_fix_fee +
          ticket.sparxo_fee);
      }

      return fee;
    };

    _.forEach(props.buyCart, t => {
      total_with_discount += t.discount_amount + tax(t, t.discount_amount) + _fee(t);
    });
  }

  _.forEach(props.buyCart, t => {
    if (!t.amount && _.has(t, 'goal') && _.has(t, 'prefilled_amount')) {
      total += t.prefilled_amount;
    } else {
      total += t.amount;
    }
  });

  const sparxo_stripe_public_key = 'test';
  const isSelected = canCheckout(props.buyCart, props.buyCart);

  return (
    <>
      <div className="sparxo-embeded-body">
        <div className="sparxo-client-view">
          <div
            className="sparxo-embeded-forms"
            style={{
              padding: '30px 0px 0'
            }}
          >
            <div className="sparxo-embeded-form">
              <h2>Billing Information</h2>

              <div className="sparxo-embeded-form-container">
                <div className="sparxo-embeded-form-row">
                  <div className="sparxo-embeded-form-group">
                    <input
                      type="text"
                      tabIndex="1"
                      placeholder="first name"
                      data-bind="attr:{placeholder:$L.first_name},textInput:firstName"
                      title="This field is required." data-orig-title=""
                    />
                    <span className="validationMessage" style={{ display: 'none' }} />
                  </div>
                  <div className="sparxo-embeded-form-group sparxo-embeded-hide-rsvp">
                    <span className="creditcard" />
                  </div>
                </div>

                <div className="sparxo-embeded-form-row">
                  <div className="sparxo-embeded-form-group">
                    <input
                      type="text"
                      tabIndex="2"
                      placeholder="last name"
                      data-bind="attr:{placeholder:$L.last_name},textInput:lastName"
                      title="This field is required." data-orig-title=""
                    />
                    <span className="validationMessage" style={{ display: 'none' }} />
                  </div>
                  <div className="sparxo-embeded-form-group sparxo-embeded-hide-rsvp">
                    <input
                      type="text"
                      tabIndex="5"
                      data-bind="attr:{placeholder:$L.card_number},inputCard:card,validationElement:card"
                      placeholder="card number"
                      title="This field is required."
                      data-orig-title=""
                    />
                    <span
                      className="validationMessage"
                      data-bind="validationMessage:card"
                      style={{ display: 'none' }}
                    />
                  </div>
                </div>

                <div className="sparxo-embeded-form-row">
                  <div className="sparxo-embeded-form-group">
                    <input
                      type="text"
                      tabIndex="3"
                      placeholder="email"
                      data-bind="attr:{placeholder:$L.email},textInput:email_address"
                      title="This field is required." data-orig-title=""
                    />
                    <span className="validationMessage" style={{ display: 'none' }} />
                  </div>
                  <div className="sparxo-embeded-form-group  sparxo-embeded-hide-rsvp">
                    <div className="sparxo-embeded-form-container m0-5">
                      <div className="sparxo-embeded-form-row mb0">
                        <div className="sparxo-embeded-form-group p05">
                          <select
                            tabIndex="6"
                            data-bind="options:$parent.buyServices.getExpMonth(),value: month"
                            title=""
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                          </select>
                          <span className="validationMessage" style={{ display: 'none' }} />
                        </div>
                        <div className="sparxo-embeded-form-group p05">
                          <select
                            tabIndex="7"
                            data-bind="options:$parent.buyServices.getExpYear(),value: year"
                            title=""
                          >
                            <option value="2020">2020</option>
                            <option value="2021">2021</option>
                            <option value="2022">2022</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                            <option value="2028">2028</option>
                            <option value="2029">2029</option>
                            <option value="2030">2030</option>
                            <option value="2031">2031</option>
                          </select>
                          <span className="validationMessage" style={{ display: 'none' }} />
                        </div>
                        <div className="sparxo-embeded-form-group p05">
                          <input
                            type="text"
                            tabIndex="8"
                            maxLength="4"
                            placeholder="cvc"
                            data-bind="attr:{ placeholder:$L.cvc },inputNumber:cvc,validationElement:cvc"
                            title="This field is required."
                            data-orig-title=""
                          />
                          <span
                            className="validationMessage"
                            style={{
                              whiteSpace: 'nowrap',
                              display: 'none'
                            }}
                            data-bind="validationMessage:cvc"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sparxo-embeded-form-row">
                  <div className="sparxo-embeded-form-group">
                    <input
                      type="text"
                      tabIndex="4"
                      placeholder="phone"
                      data-bind="attr:{ placeholder:$L.phone },inputPhone:phone,validationElement:phone"
                      title="This field is required." data-orig-title=""
                    />
                      <span
                        className="validationMessage"
                        data-bind="validationMessage:phone"
                        style={{ display: 'none' }}
                      />
                  </div>
                  <div className="sparxo-embeded-form-group">
                    <input
                      type="text"
                      tabIndex="9"
                      placeholder="postal code"
                      data-bind="attr:{ placeholder:$L.zip_code },textInput:zipCode"
                      title="This field is required." data-orig-title=""
                    />
                    <span className="validationMessage" style={{ display: 'none' }} />
                  </div>
                </div>

              </div>
            </div>
            <div className="sparxo-embeded-securedesc">
              <i className="icon icon-lock" />
              <span>
                &nbsp; Your personal information above is transmitted over SSL secured connection using
                256 bit bank level encryption.
              </span>
            </div>
          </div>
        </div>
      </div>
    <StripeCard
      stripePublicKey={sparxo_stripe_public_key}
      onHandleSubmit={handleStripSubmit}
    />

    <div className={`sparxo-embeded-footer ${isSelected ? 'isSelected' : ''}`}>
      <div className="sparxo-embeded-footer-inner">
        <div
          className="sparxo-embeded-info"
          data-bind="visible:showAmount()"
          style={{
            marginLeft: 0
          }}
        >
          <p
            className={`${props.isIssetDiscount ? 'has-discount' : ''}`}
            data-bind="css:{'has-discount':buyServices.hasDiscount}"
          >
            <span style={{ textTransform: 'uppercase' }}>total </span>
            <span className="raw-price ">
              <span
                className="amount"
                title={format(currency[`${props.eventDetail.default_currency}`], total)}
              >
                {format(currency[`${props.eventDetail.default_currency}`], total)}
              </span>
            </span>
            <span className="actual-price">
              <span
                className="amount"
                title={format(currency[`${props.eventDetail.default_currency}`], total_with_discount)}
              >
                {format(currency[`${props.eventDetail.default_currency}`], total_with_discount)}
              </span>
            </span>
          </p>
        </div>
        <div
          className="sparxo-embeded-buttons"
          data-bind="foreach:buttons"
          style={{
            marginRight: 0
          }}
        >
          <button
            type="button"
            data-bind="click:$root.clickProxy.bind($root,$data),css:$data.cls"
            className="sparxo-embeded-btn-back"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <i className="icon icon-chevron-left" data-bind="visible:$data.icon,css:$data.icon" />
            <span data-bind="i18n:text">back</span>
          </button>

          <button
            type="button"
            data-bind="click:$root.clickProxy.bind($root,$data),css:$data.cls"
            onClick={(e) => {
              e.preventDefault();
              handleStripSubmit();
            }}
          >
            <i className="icon" data-bind="visible:$data.icon,css:$data.icon" style={{ display: 'none' }} />
            <span>Continue</span>
          </button>
        </div>
        <div className="clearfix" />
      </div>
    </div>
    </>
  );
};
